import _useViewerQuery from "./__generated__/useViewerQuery.graphql";
import { graphql, useLazyLoadQuery } from "@workflows/runtime-web";
import { FilterInputType, useTenantId } from "@workflows/ui";
import { SortInputValue } from "../sort";
import { useViewerQuery } from "./__generated__/useViewerQuery.graphql";
interface UseViewerType {
  numberOfTasks?: number;
  taskSort?: SortInputValue[];
  filter?: FilterInputType | null;
  page?: number;
  limit?: number;
}
export const useViewer = ({
  numberOfTasks,
  taskSort,
  filter,
  page,
  limit
}: UseViewerType) => {
  const tenantId = useTenantId();
  const {
    viewer
  } = useLazyLoadQuery<useViewerQuery>(Query, {
    numberOfTasks,
    taskSort,
    filter,
    tenantIds: [tenantId],
    page,
    limit
  }, {
    fetchPolicy: "network-only"
  });
  return viewer;
};
const Query = (_useViewerQuery.hash && _useViewerQuery.hash !== "ce02292af443d68b3c115b44f225dd2e" && console.error("The definition of 'useViewerQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useViewerQuery);